/* eslint-disable */
import * as R from 'ramda';

export default function editDepartmentProceduresDialogController(
  $filter,
  $rootScope,
  $scope,
  $q,
  $timeout,
  alerts,
  ssDialogService,
  loaderService,
  bcpDataService,
  changeProcedureConfirmDialog
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleNavToProcess = _handleNavToProcess;
  vm.handleFormSubmit = _handleFormSubmit;
  vm.getCSSClass = getCssClass;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    loaderService.showViewLoader = false;

    _initActiveProcess();

    $scope.$on('refreshBCPAssessmentProcesses', (event, opt) => {
      if (opt.processes) {
        _updateProcess(opt.processes);
      }
    });
  }

  function _initActiveProcess() {
    // vm.activeProcess = $filter('filter')(vm.processes, { showEditDepartmentProcedure: true, }, true)[0];
    vm.activeProcess = vm.processes.find(process => process.showEditDepartmentProcedure);
    vm.canSeeSubmit = vm.activeProcess.showEditImpactInformation;
  }

  function _updateProcess(newProcesses) {
    R.forEach((process) => {
        const p = R.find(R.propEq('assessmentProcessId', process.assessmentProcessId), vm.processes);

        R.forEach((funct) => {
          const fIdx = R.findIndex(
            R.propEq('assessmentFunctionId', funct.assessmentFunctionId),
            p.assessmentFunctions
          );

          p.assessmentFunctions = R.update(fIdx, funct, p.assessmentFunctions);
        }, process.assessmentFunctions);
      }, newProcesses);
  }

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.bcp.editDepartmentProceduresDialog);
  }

  function _handleNavToProcess(processId) {
    const newActiveProcess = $filter('filter')(vm.processes, { processId, }, true)[0];
    if (vm.activeProcess !== newActiveProcess) {
      vm.contentPaneIsFaded = true;
      $timeout(() => {
        vm.activeProcess = newActiveProcess;
        vm.contentPaneIsFaded = false;
        }, 100);
    }
  }

  function saveChangedProcess() {
    const _changedProcesses = [];
    angular.forEach(vm.processes, (_process) => {
      const process = angular.copy(_process);
      const _changedFunctions = [];
      angular.forEach(_process.assessmentFunctions,(eachFunction) => {
        if (eachFunction.procedureTextChanged) {
          _changedFunctions.push(eachFunction);
        }
        if (eachFunction.hasRecoveryProcedure !== eachFunction.hasRecoveryProcedureOld) {
          if (eachFunction.hasRecoveryProcedure === false) {
            eachFunction.recoveryProcedureText = '';
            eachFunction.procedureTextChanged = true;
          }
          _changedFunctions.push(eachFunction);
        }
      });

      if (_changedFunctions.length > 0) {
        process.assessmentFunctions = _changedFunctions;
        _changedProcesses.push(process);
      }
    });
    return _changedProcesses;
  }

  function getProcessToSave(processes, changedProcesses) {
    const processesToSave = [];
    const processesToConfirm = [];
    angular.forEach(processes, (eachProcess) => {
        const _find = R.find(R.propEq('processId', eachProcess.processId), changedProcesses);

        if (_find) {
          if (eachProcess.assessmentFunctions && eachProcess.assessmentFunctions.length > 0) {
            const functionsToSave = [];
            const functionsToConfirm = [];
            angular.forEach(eachProcess.assessmentFunctions,(eachFunction) => {
              const _findFunction = R.find(
                R.propEq('assessmentFunctionId', eachFunction.assessmentFunctionId),
                _find.assessmentFunctions
              );

              if (_findFunction) {
                functionsToConfirm.push(eachFunction);
              } else {
                functionsToSave.push(eachFunction);
              }
            });

            if (functionsToSave.length > 0) {
              const _saveProcess = angular.copy(eachProcess);
              _saveProcess.assessmentFunctions = functionsToSave;
              processesToSave.push(_saveProcess);
            }

            if (functionsToConfirm.length > 0) {
              const _confirmProcess = angular.copy(eachProcess);
              _confirmProcess.assessmentFunctions = functionsToConfirm;
              processesToConfirm.push(_confirmProcess);
            }
          }
        } else {
          processesToSave.push(eachProcess);
        }
      }
    );
    return { processesToSave, processesToConfirm };
  }

  function _saveImpactAnalysis($event) {
    const _processes = saveChangedProcess();
    const dfdItem = $q.defer();
    if (_processes.length > 0) {
      bcpDataService.checkProcessHasBeenUpdate(_processes).then((response) => {
        if (response.status === 200 || response.status === 201) {
          if (response.data.length > 0) {
            const result = getProcessToSave(_processes, response.data);
            if (result.processesToSave.length > 0) {
              bcpDataService.saveDocumentProcedure(vm.assessmentId, result.processesToSave).then((results) => {
                _updateProcess(results.data);
                if (result.processesToConfirm.length > 0) {
                  _handleConfirmChange($event, result.processesToConfirm, dfdItem);
                }
                // dfdItem.resolve();
              });
            } else if (result.processesToConfirm.length > 0) {
              _handleConfirmChange($event, result.processesToConfirm, dfdItem);
              // dfdItem.resolve();
            }
          } else {
            bcpDataService.saveDocumentProcedure(vm.assessmentId, _processes).then((results) => {
              _updateProcess(results.data);
              dfdItem.resolve();
            });
          }
        }
      }).catch(() => {
        alerts.error('An error occurred while saving the recovery procedure.');
        dfdItem.reject();
      });
    } else {
      dfdItem.resolve();
    }

    return dfdItem.promise;
  }

  function _handleFormSubmit($event) {
    _saveImpactAnalysis($event).then(() => {
      const processesToSubmit = $filter('filter')(
        vm.processes, { readyToSubmit: true }
      );

      const processIdsToSubmit = [];

      if (processesToSubmit.length > 0) {
        angular.forEach(processesToSubmit, (process) => {
          processIdsToSubmit.push(process.assessmentProcessId);
        });

        bcpDataService.submitAssessmentProcesses(processIdsToSubmit).then(() => {
          alerts.success('The BCP Department Procedures have been saved successfully.');
          $rootScope.$broadcast('refreshBCPAssessments');
          $rootScope.$broadcast('refreshNotifications');
        });
      } else {
        alerts.success('The BCP Department Procedures have been saved successfully.');
        $rootScope.$broadcast('refreshBCPAssessments');
        $rootScope.$broadcast('refreshNotifications');
      }
      if (vm.saveType === 'saveAndClose') {
        ssDialogService.hide(ssDialogService.dialogs.bcp.editDepartmentProceduresDialog);
      }
    });
  }

  function getCssClass(process) {
    let procedureCount = 0;
    angular.forEach(process.assessmentFunctions,(functions) => {
      if (functions.hasRecoveryProcedure) {
        procedureCount += 1;
      }
    });

    if (process.assessmentFunctions && process.assessmentFunctions.length > 0) {
    }

    if (procedureCount === 0) {
      return 'status-neutral';
    }

    if (procedureCount === process.assessmentFunctions.length) {
      return 'status-good';
    }

    if (procedureCount < process.assessmentFunctions.length) {
      return 'status-pending';
    }
  }

  function _handleConfirmChange($event, _processes, dfdItem) {
    ssDialogService.dialogs.bcp.changeConfirmDialog = ssDialogService.alert(
      changeProcedureConfirmDialog.getOptions($event, {
        assessmentId: vm.assessmentId,
        processes: _processes,
        dfdItem
      })
    );

    ssDialogService.show(ssDialogService.dialogs.bcp.changeConfirmDialog);
  }
}

editDepartmentProceduresDialogController.$inject = [
  '$filter',
  '$rootScope',
  '$scope',
  '$q',
  '$timeout',
  'alerts',
  'ssDialogService',
  'loaderService',
  'bcpDataService',
  'changeProcedureConfirmDialog'
];
